<template>
  <div class="listContainer">
    <!-- 增加&搜索 -->
    <section>
      <section class="tableContent">
        <!-- :tree-config="{ children: 'children', expandAll: true }" -->
        <vxe-table
          :tree-config="{ children: 'children' }"
          resizable
          ref="xTree"
          :data="data"
        >
          <vxe-table-column
            field="project_name"
            title="项目名称"
            tree-node
          ></vxe-table-column>
          <vxe-table-column title="状态/城市数量">
            <template v-slot="{ row }">
              <!-- <span>{{row.province+row.city}}</span> -->
              <span v-show="row.level == 3">{{ row.status_text }}</span>
              <span v-show="row.level != 3">{{ row.city_len }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="admin" title="关联人员">
            <template v-slot="{ row }">
              <span
                class="adminList"
                v-for="(item, k) in row.project_admin_list"
                :key="k"
              >
                <span v-show="k > 0 && k < row.project_admin_list.length"
                  >&nbsp;|&nbsp;</span
                >
                <span>
                  {{ item.user_name }}
                </span>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="operation" title="操作">
            <template v-slot="{ row }">
              <div class="provinceStyle">
                <a style="color: #f56c6c" @click="setPage(row)">设置</a>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </section>
    </section>
    <!-- 设置 -->
    <aside class="dialogsBox" v-show="showIsSet">
      <div>
        <h3>设置</h3>
        <a-icon class="close" type="close-circle" @click="showIsSet = false" />
        <ul>
          <li>
            <label>项目名称：</label>
            <p>{{ setDetails.project_name }}</p>
          </li>
          <!-- <li>
            <label>状态：</label>
            <a-select
              style="width: 150px"
              v-model="status"
              show-search
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in statusList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </li> -->
          <li>
            <label>关联人员：</label>
            <a-select
              style="width: 200px"
              v-model="project_admin_id"
              mode="multiple"
              show-search
              :filter-option="filterOption"
            >
              <a-select-option
                :value="item.id"
                v-for="item in userList"
                :key="item.id"
              >
                {{ item.user_name }}
              </a-select-option>
            </a-select>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitSet"> 确认 </a-button>
        </div>
      </div>
    </aside>
    <!-- 设置 end -->
  </div>
</template>
<script>
import axios from "axios";
import { pcaa } from "area-data";
export default {
  data() {
    return {
      filterName: "",
      showIsAdd: false,
      data: [],
      query_field: "",
      province: [],
      pcaa: pcaa,
      city: "",
      addressList: [],
      setDetails: {},
      showIsSet: false,
      statusList: [
        {
          name: "出访/接洽",
          id: 10
        },
        {
          name: "意向",
          id: 20
        },
        {
          name: "报价",
          id: 30
        },
        {
          name: "搁置",
          id: 40
        },
        {
          name: "未签约",
          id: 50
        },
        {
          name: "签约",
          id: 60
        },
        {
          name: "提前解约",
          id: 70
        },
        {
          name: "合同期满终止",
          id: 80
        },
        {
          name: "续约",
          id: 90
        }
      ],
      userList: [],
      project_admin_id: [],
      status: ""
    };
  },
  components: {},
  mounted() {
    this.getData();
    // this.$refs.xTree.setAllTreeExpand(true);
    this.iterateCities();
    this.getUser();
  },
  methods: {
    getUser() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/employeeList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000,
        employee_type: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data.data;
          // console.log(this.userList);
        }
      });
    },
    submitSet() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/setStatus";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        status: this.status,
        project_admin_id: JSON.stringify(this.project_admin_id),
        project_id: this.setDetails.id
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.showIsSet = false;
            this.$message.success("设置成功");
            this.getData();
            // this.$refs.xTree.setAllTreeExpand(true);
          } else {
            this.showIsSet = false;
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    },
    setPage(item) {
      // console.log(item);
      this.showIsSet = true;
      this.setDetails = item;
      if (item.status != 0) {
        this.status = item.status;
      }
      this.project_admin_id = [];
      if (item.project_admin_list != "") {
        item.project_admin_list.forEach(element => {
          this.project_admin_id.push(element.id);
        });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    iterate(obj, panelIndex) {
      // panelIndex 表示所在 panel 的索引
      var temp = [];
      for (var key in obj) {
        temp.push({
          label: obj[key],
          value: key,
          panelIndex: panelIndex
        });
      }
      return temp;
    },
    iterateCities() {
      var temp = [];
      var provinces = this.iterate(this.pcaa["86"], 0);
      for (var i = 0, l = provinces.length; i < l; i++) {
        var item = {};
        item["label"] = provinces[i].label;
        item["value"] = provinces[i].value;
        item["panelIndex"] = provinces[i].panelIndex;

        item["children"] = this.iterate(this.pcaa[provinces[i].value], 1);
        temp.push(item);
      }
      this.addressList = temp;
    },
    onSearch() {
      this.getData();
    },
    toggleExpandChangeEvent({ row, expanded }) {
      console.log("节点展开事件" + expanded);
    },
    getTreeExpansionEvent() {
      let treeExpandRecords = this.$refs.xTree.getTreeExpandRecords();
      this.$XModal.alert(treeExpandRecords.length);
    },
    getData() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectListData";
      //   console.log(url)
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000,
        query_field: this.query_field
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          // console.log(this.data);
        }
        // console.log(res);
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    padding: 14px 2%;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      span,
      input,
      p,
      label {
        display: inline-block;
        vertical-align: top;
        line-height: 30px;
      }
      button {
        vertical-align: top;
      }
    }
  }
  .provinceStyle {
    a {
      margin-left: 10px;
    }
  }
  .adminList {
    display: inline-block;
    vertical-align: top;
    > span {
      display: inline-block;
    }
  }
  .dialogsBox {
    > div {
      > ul {
        > li {
          label,
          p {
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.listContainer {
  .tableContent {
    padding: 0 2%;
    table {
      border: 1px solid #e8e8e8;
      width: 100% !important;
      border-collapse: collapse;
      text-align: left;
      border-radius: 4px 4px 0 0;
      thead {
        th {
          background: #fafafa;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
          padding: 8px 16px;
          font-size: 14px;
        }
      }
    }
    .vxe-table--body-wrapper,
    .vxe-table--fixed-left-body-wrapper,
    .vxe-table--fixed-right-body-wrapper {
      overflow: unset;
    }
    .vxe-table .vxe-cell {
      white-space: unset;
    }
  }
}
</style>
